import {
  observable, flow, action, makeObservable,
} from 'mobx';
import BaseStore from './BaseStore';
import { ExamCenterReviewAPIInstance } from '../api/exam_center_review';
import { DrivingSchoolsType } from '../components/ReviewForm/ExamCenterReviewForm/constants';

class ExamCenterReviewStore extends BaseStore {
  isSent = false;
  rating = 0;
  reviewId = '';
  selectedSchoolType = DrivingSchoolsType.TRADITIONAL;

  constructor() {
    super();

    makeObservable(this, {
      isSent: observable,
      rating: observable,
      setRating: action.bound,
      resetExamCenterReviewStore: action.bound,
    });
  }

  setRating(amount) {
    this.rating = amount;
  }

  setSchoolType(type) {
    this.selectedSchoolType = type;
  }

  create = flow(function* (payload, setErrors, setSubmitting) {
    try {
      const { data } = yield ExamCenterReviewAPIInstance.create(payload);
      this.isSent = true;
      this.reviewId = data.id;
    } catch (e) {
      if (e.response) {
        setErrors(e.response.data.errorMessages);
      } else {
        // eslint-disable-next-line no-console
        console.error(e);
      }
      setSubmitting(false);
    }
  });

  resetExamCenterReviewStore() {
    this.rating = 0;
    this.reviewId = '';
  }
}

export default new ExamCenterReviewStore();
